import { AnyAction } from 'redux';
import { CHANGE_JIT_ORGANIZATION_SELECT, CHANGE_ORGANIZATION_SELECT } from '../constants';
import { defaultOrgId, localStore } from '@app/helpers';

const tryGetInitialOrg = (): string => {
    try {
        const orgFilter = localStore.getItem('org_filter');

        if (orgFilter === null) {
            return defaultOrgId;
        }
        else {
            return orgFilter;
        }
    }
    catch {
        return defaultOrgId;
    }
};

const initialUserState = {
    selectedOrganization: tryGetInitialOrg(),
    selectedJitOrganization: null
};

export function organizationSelect(state = initialUserState, action: AnyAction) {
    const { payload, type } = action;

    switch (type) {
        case CHANGE_ORGANIZATION_SELECT:
            return {
                ...state,
                selectedOrganization: payload
            };
        case CHANGE_JIT_ORGANIZATION_SELECT:
            return {
                ...state,
                selectedJitOrganization: payload
            };
        default:
            return state;
    }
}
